var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.questions.examQuestionsId
    ? _c(
        "div",
        { staticClass: "exam-test-paper-component" },
        [
          _c("dsf-exam-item-box", {
            attrs: {
              readOnly: _vm.previewStatus,
              subjects: _vm.questions,
              "hide-mark": true,
              "exam-index": _vm.questions.dsOrder - 1,
            },
          }),
          _c(
            "div",
            { staticClass: "footer-buttons" },
            [
              _c("dsf-button", { on: { click: _vm.savePaper } }, [
                _vm._v(_vm._s(_vm.saveText)),
              ]),
              _vm.showClose
                ? _c(
                    "dsf-button",
                    { attrs: { type: "plain" }, on: { click: _vm.close } },
                    [_vm._v("关闭")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }